[data-slot='dialog-content'].installation-dialog-container {
	width: 400px;
	max-width: 500px;
	padding-inline-start: 20px;
	padding-inline-end: 20px;
	padding-bottom: 2rem;
	height: unset;
}

[data-slot='dialog-content'].installation-dialog-container h3 {
	font-family: var(--app-title-font-family);
	font-size: 2rem;
}

[data-slot='dialog-content'].installation-dialog-container p {
	font-family: var(--content-font-family);
	font-size: 1rem;
	line-height: 1.2rem;
	padding: 0px;
	margin-bottom: 10px;
}

[data-slot='dialog-content'].installation-dialog-container li {
	font-size: 0.9rem;
	line-height: 1.2rem;
	margin-bottom: 5px;
}

[data-slot='dialog-content'].installation-dialog-container ol {
	list-style: decimal;
	text-align: start;
	margin-inline-end: auto;
	margin-inline-start: 15px;
}

[data-slot='dialog-content'].installation-dialog-container b {
	font-weight: bold;
}

[data-slot='dialog-content'].installation-dialog-container
	.installation-dialog {
	padding-inline-start: 2rem;
	padding-inline-end: 2rem;
}

.installation-dialog {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.installation-dialog h3 {
	font-size: 1.2rem;
	font-weight: bold;
	margin-bottom: 15px;
	font-family: var(--app-headline-font-family);
}

.installation-dialog p:last-of-type {
	margin-bottom: 20px;
}

.installation-dialog img {
	max-width: 250px;
	margin-bottom: 20px;
}

.installation-dialog button {
	cursor: pointer;
	border: none;
	background: none;
}

.installation-dialog > div {
	width: 100%;
	font-size: 0.8rem;
	height: 50px;
	background: #f9f9f9;
	padding-inline-start: 0;
	padding-inline-end: 0;

	display: flex;
	justify-content: center;
	align-items: center;
}

.installation-dialog button div {
	width: 24px;
	height: 24px;
}

.installation-dialog svg {
	margin: 0px;
	vertical-align: bottom;
	padding: 2px;
	width: 20px;
	height: 20px;
	stroke: #4e97fd;
	display: inline;
}

@media screen and (max-width: 767px) {
	[data-slot='dialog-content'].installation-dialog-container {
		max-width: 90vw;
		height: 300px;
	}
}
